import React, { lazy, Suspense } from 'react';

// 创建带错误边界的懒加载组件
function lazyLoadComp(importFunc) {
  const Component = lazy(importFunc);

  return function AsyncComponentWrapper(props) {
    const { loadingImg = null, ...otherProps } = props;

    const loadingImgReander = () => {
      if (!loadingImg) return null;
      return <img style={{ width: '100vw', height: '100vh', objectFit: 'cover' }} src={loadingImg} alt="loading" />;
    };
    return (
      <Suspense fallback={loadingImgReander()}>
        <Component {...otherProps} />
      </Suspense>
    );
  };
}

export default lazyLoadComp;
